let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("3L2aP")]).then(() => parcelRequire('8degK'));